<template>
  <b-container>
    <b-row class="vh-100 text-center" align-v="center">
      <b-col>
        <b-card class="hosting-card">Video hosting</b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

export default {
}
</script>

<style>

.hosting-card {
  max-width: 24em;
  margin: auto;
}

</style>
